import { configureStore } from '@reduxjs/toolkit';

import rootReducer from './rootReducer';

const store = configureStore({
    reducer: rootReducer,
    // Redux DevTools enabled by default in development
    // Thunk middleware included by default
});

export default store;